import Vue from 'vue'

export default {
  getAll() {
    return Vue.http.get(`/api/local/v1/payments`)
              .then((response) => Promise.resolve(response.data))
              .catch((error) => Promise.reject(error))
  }
}
